import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background-color: #2a292c;
`;

export const FooterWrap = styled.div`
  padding: 10px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;


export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 16px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const SocialLogo = styled.h1`
  color: #fff;
  justify-self: start;
  text-decoration: none;
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: bold;
  line-height: 25px;

  @media screen and (max-width: 415px) {
    text-align: center;
  }
`;

export const FooterTeam = styled.small`
  color: #fff;
  margin-bottom: 16px;
  line-height: 25px;
  align-items: center;
  position: center;
  justify-self: center;
  text-decoration: none;
  margin: auto;
  
`;

export const FooterLink = styled.a`
  color: #fff;
  margin-bottom: 16px;
  line-height: 25px;
  align-items: center;
  position: center;
  justify-self: center;
  text-decoration: none;
  margin: auto;

  &:hover {
    color: #8659fa;
  }

  &:active {
    color: #05c865;
  }
`

export const BGMusic = styled.audio`
  display: hidden;
`